module.exports = __webpack_public_path__ + "img/send-parent.3808250a.png";